import React from 'react';

import Modal from "components/Modal";
import PaymentFail from 'components/ModalFailedPayment/PaymentFail';
import { actionsType } from 'config/constants';


const ModalFailedPayment = () => {

    return (
        <Modal  customClass={'modal-fail-checkout'} actionOpen={actionsType.MODAL.FAILED_PAYMENT_OPEN} actionClose={actionsType.MODAL.FAILED_PAYMENT_CLOSE} >
            <PaymentFail />
        </Modal>
    )
}

export default ModalFailedPayment;
